import { SvgIcon, SxProps } from "@mui/material";
import ArrowRotateRightSvg from "jsx:../../../Images/Icons/FontAwesome/light/arrow-rotate-right.svg";

export function ArrowRotateRightIcon(props: SxProps) {
    return (
        <SvgIcon component={ArrowRotateRightSvg} inheritViewBox sx={props} />
    );
}
